import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { stripMarkdown } from './RowListEditors';
import AutoGrowingTextarea from './AutoGrowingTextarea';

const BulletItem = ({ item, idx, readOnly, update, removeRow, itemsLength }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    return (
        <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 12,
                padding: '4px 8px',
                borderRadius: 6,
                background: isHovered && !readOnly ? '#F8F9FA' : 'transparent',
                transition: 'background 0.15s',
                marginBottom: 2
            }}
        >
            <span style={{ 
                color: '#64748B', 
                fontSize: 18, 
                lineHeight: '24px', 
                fontWeight: 800,
                userSelect: 'none',
                marginTop: -2
            }}>
                •
            </span>
            <div style={{ flex: 1, position: 'relative' }}>
                <AutoGrowingTextarea
                    disabled={readOnly}
                    value={stripMarkdown(item)}
                    onChange={e => update(idx, e.target.value)}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    placeholder={`Bullet point ${idx + 1}`}
                    rows={1}
                    style={{
                        width: '100%',
                        fontSize: 14,
                        lineHeight: '24px',
                        color: '#1E293B',
                        background: 'transparent',
                        border: 'none',
                        outline: 'none',
                        padding: 0,
                        resize: 'none',
                        overflow: 'hidden',
                        minHeight: 24,
                    }}
                />
            </div>
        </div>
    );
};

const BulletListEditor = ({ value = [''], onChange, readOnly }) => {
    const items = Array.isArray(value) ? value : [''];
    const update = (idx, val) => { const next = [...items]; next[idx] = val; onChange(next); };
    const addRow = () => onChange([...items, '']);
    const removeRow = (idx) => onChange(items.filter((_, i) => i !== idx));

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {items.map((item, idx) => (
                <BulletItem 
                    key={idx}
                    item={item}
                    idx={idx}
                    readOnly={readOnly}
                    update={update}
                    removeRow={removeRow}
                    itemsLength={items.length}
                />
            ))}
        </div>
    );
};

export default BulletListEditor;
